export default __webpack_public_path__ + "static/media/use_action_cz.2d494067.png";